/* ============================================================
   VIVID Flavor Cross-Sell — assets/vcd-crosssell.js
   NextGen Supplements

   Fügt die vorgeschlagene zweite Geschmacksrichtung (1-Dose-OTP)
   zum Warenkorb hinzu und dockt dabei an den bestehenden
   Section-Render-Flow des Cart Drawers an.

   - Eigenes Custom Element <vcd-crosssell> — fasst CartDrawer/
     CartItems NICHT an, kann mit nichts kollidieren.
   - Add via /cart/add.js mit sections-Param, danach
     cart-drawer.renderContents() (genau wie der Theme-Add-Flow).
   - Reicht das __kaching_bundles-Property der auslösenden Zeile
     1:1 mit, damit Kaching den Mengenrabatt automatisch anwendet.
   ============================================================ */

(function () {
  if (window.customElements && customElements.get('vcd-crosssell')) return;

  class VcdCrosssell extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this._onClick);
    }

    _onClick(evt) {
      evt.preventDefault();
      if (this.loading) return;

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this._setLoading(true);

      const properties = {};
      const kaching = this.dataset.kaching;
      if (kaching) properties['__kaching_bundles'] = kaching;

      const body = {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: properties,
          },
        ],
        sections: this._sectionsToRender(),
        sections_url: window.location.pathname,
      };

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((parsed) => {
          // Fehlerobjekt von /cart/add.js trägt ein status-Feld (z.B. 422)
          if (parsed && parsed.status) {
            this._setLoading(false);
            return;
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
            drawer.renderContents(parsed);
          } else {
            // Fallback: nur wenn der erwartete Flow nicht verfügbar ist
            window.location.reload();
          }
          // Kein _setLoading(false) nötig: das Element wird beim
          // Re-Render des Drawers ohnehin neu erzeugt.
        })
        .catch(() => {
          this._setLoading(false);
        });
    }

    _sectionsToRender() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');
      }
      return 'cart-drawer,cart-icon-bubble';
    }

    _setLoading(state) {
      this.loading = state;
      this.classList.toggle('vcd-xsell--loading', state);
      if (!this.button) return;
      this.button.toggleAttribute('disabled', state);
      this.button.setAttribute('aria-busy', state ? 'true' : 'false');
    }
  }

  customElements.define('vcd-crosssell', VcdCrosssell);
})();